export const SUPPLEMENTS = {
  key: 'SUPPLEMENTS',
  value: 6,
  group: 2,
  title: 'health-record.medications.supplement_title',
  sub_title: 'Supplement',
  menu_title: 'health-record.medications.supplement_title',
  imageURL: require('@assets/images/Health-Record-Icons/Icon-Supplements.svg'),
  icon: 'pill',
  editor: 'MedicationEditor',
  message_translate: 'health-record.medications.message',
  model_name: 'supplement',
  resource: 'hr/supplement/',
  plain_resource: 'supplement',
  id: 'hr_id',
  headers: [
    {
      text: 'health-record.medications.supplement',
      value: 'record.supplement',
    },
    {
      text: 'health-record.medications.frequency',
      value: 'record.frequency_and_dosage',
    },
    {
      text: 'health-record.medications.start-date',
      value: 'record.start_formatted',
    },
    {
      text: 'health-record.medications.end-date',
      value: 'record.end_formatted',
    },
    {
      text: 'health-record.actions',
      value: 'actions',
      sortable: false,
      width: '100px',
    },
  ],
  sortables: {
    record: {
      start_formatted: 'start',
      end_formatted: 'end',
      frequency_and_dosage: 'dosage',
      supplement_stop_reason: {
        value: 'supplement_stop_reason',
      },
      supplement: 'supplement',
      ingredient: 'ingredient',
    },
  },
  show_menu: true,
  background: 'linear-gradient(122.25deg, #3949AB 3.07%, #5C6BC0 100%)',
  color: '#5767BE',
  opaque: '#D9DDEE',
}
